import React, { Component } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import queryString from "query-string";

import "../../css/tracks.less";

import "./MessageBoardPage.less";
import MessageBoardFooter from "./MessageBoardFooter";
import MessageBoardSearchContainer from "../../Containers/MessageBoardSearchContainer";
import MessageBoardHeader from "./MessageBoardHeader";
import MessageBoardRightNav from "../../Components/Elements/Global/RightNav";

class MessageBoardSearchPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      terms: "",
    };
  }

  componentDidMount() {
    const queryStringParams = queryString.parse(this.props.location.search);
    this.setState({ terms: queryStringParams.terms });
  }

  render() {
    const terms = this.state.terms || "";
    return (
      <div className="page-message-board">
        <MessageBoardHeader />
        <Row>
          <Col xs={12} sm={12} md={9}>
            <div className="totd-box">
              <div className="sub-header">Search results for "{terms}"</div>

              {terms && <MessageBoardSearchContainer filter={terms} />}

              <Link to="/message-board">Back to Most Recent Topics</Link>
            </div>
          </Col>
          <Col xs={12} sm={12} md={3}>
            <MessageBoardRightNav />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <MessageBoardFooter />
          </Col>
        </Row>
      </div>
    );
  }
}

export default MessageBoardSearchPage;
